export const AdminNameField = ({ data }: { data: any }) => {
    return <span>{data.name}</span>;
};
